export const RecordShareRecipientTypeEnum = Object.freeze({
    PHYSICIAN: 'PHYSICIAN',
    ANCILLARY: 'ANCILLARY',
    OTHER: 'OTHER',
})

export const RECORD_SHARE_RECIPIENT_OPTIONS = Object.freeze([
    { value: RecordShareRecipientTypeEnum.PHYSICIAN, label: 'Physician/Medical Provider' },
    { value: RecordShareRecipientTypeEnum.ANCILLARY, label: 'Ancillary Medical Service' },
    { value: RecordShareRecipientTypeEnum.OTHER, label: 'Other' },
])

export const getRecipientLabel = (type) => {
    const match = RECORD_SHARE_RECIPIENT_OPTIONS.find((opt) => opt.value === type)
    return match ? match.label : type || ''
}

export default RecordShareRecipientTypeEnum
